import { defineStore } from 'pinia';
import type { OrderStoreState } from '#/order';
const useOrderStore = defineStore('app-order', {
	// 持久化存储，可以根据自己需求配置哈
	state: (): OrderStoreState => ({
		orderId: 0,
		channelTradeNo: '',
		aesCryptoStr: '',
		sessionId: '',
		servicePhone: '',
		workTime: '',
		email: '',
		orderOriginPrice: 0,
	}),
	actions: {
		setOrderId(orderId: number): void {
			this.orderId = orderId;
		},
		setChannelTradeNo(channelTradeNo: string): void {
			this.channelTradeNo = channelTradeNo;
		},
		setAesCryptoStr(aesCryptoStr: string): void {
			this.aesCryptoStr = aesCryptoStr;
		},
		setSessionId(sessionId: string): void {
			this.sessionId = sessionId;
		},
		setServicePhone(servicePhone: string) {
			this.servicePhone = servicePhone;
		},
		setWorkTime(workTime: string) {
			this.workTime = workTime;
		},
		setOrderOriginPrice(orderOriginPrice: number) {
			this.orderOriginPrice = orderOriginPrice;
		},
		setEmail(email: string) {
			this.email = email;
		}
	},
	getters: {
		getOrderId(): number {
			return this.orderId;
		},
		getChannelTradeNo(): string {
			return this.channelTradeNo;
		},
		getAesCryptoStr(): string {
			return this.aesCryptoStr;
		},
		getSessionId(): string {
			return this.sessionId;
		},
		getServicePhone(): string {
			return this.servicePhone;
		},
		getWorkTime(): string {
			return this.workTime;
		},
		getOrderOriginPrice(): number {
			return this.orderOriginPrice;
		},
		getEmail(): string {
			return this.email;
		}
	},
	//persist定义要做判断，因为localStorage是客户端参数，所以需要加process.client
	persist: process.client && {
		storage: sessionStorage,
		paths: ['orderId', 'channelTradeNo', 'aesCryptoStr', 'sessionId', 'servicePhone', 'workTime', 'orderOriginPrice', 'email']
	}
});

export const setOrderIdFun = (orderId: number) => {
	useOrderStore().setOrderId(orderId);
};
export const getOrderIdFun = () => {
	return useOrderStore().getOrderId;
};

export const setChannelTradeNoFun = (channelTradeNo: string) => {
	useOrderStore().setChannelTradeNo(channelTradeNo);
};
export const getChannelTradeNoFun = () => {
	return useOrderStore().getChannelTradeNo;
};
export const setAesCryptoStrFun = (aesCryptoStr: string) => {
	useOrderStore().setAesCryptoStr(aesCryptoStr);
};
export const getAesCryptoStrFun = () => {
	return useOrderStore().getAesCryptoStr;
};
export const setSessionIdFun = (sessionId: string) => {
	useOrderStore().setSessionId(sessionId);
};
export const getSessionIdFun = () => {
	return useOrderStore().getSessionId;
};
export const setServicePhoneFun = (servicePhone: string) => {
	useOrderStore().setServicePhone(servicePhone);
};
export const getServicePhoneFun = () => {
	return useOrderStore().getServicePhone;
};
export const setWorkTimeFun = (workTime: string) => {
	useOrderStore().setWorkTime(workTime);
};
export const getWorkTimeFun = () => {
	return useOrderStore().getWorkTime;
};
export const setOrderOriginPriceFun = (orderOriginPrice: number) => {
	return useOrderStore().setOrderOriginPrice(orderOriginPrice);
};
export const getOrderOriginPriceFun = () => {
	return useOrderStore().getOrderOriginPrice;
};
export const setEmailFun = (email: string) => {
	useOrderStore().setEmail(email);
};
export const getEmailFun = () => {
	return useOrderStore().getEmail;
};
